<template>
  <div class="sideList">
    <a
      class="sideList__item sideList__tel"
      @mouseenter="MouseFun('show2')"
      @mouseleave="mouseleave('show2')"
    >
      <div class="sideList__topOutside">
        <transition name="fade">
          <div class="sideList__topShow sideList__show" v-if="show2">
            400-0960-592
            <div class="sideList__triangle"></div>
          </div>
        </transition>
      </div>
    </a>
    <!-- <img src="./../static/" alt=""> -->
    <div class="sideList__item sideList__top" @click="toTop"></div>
  </div>
</template>

<script>
export default {
  name: "sideList",
  data() {
    return {
      router: true,
      defaultActive: "/",
      isShow: false,
      show1: false,
      show2: false,
    };
  },
  mounted() {},
  methods: {
    toTop() {
      // 识别滚动容器：优先可滚动的 .el-main，否则滚动根容器
      const rootEl = document.scrollingElement || document.documentElement || document.body;
      const main = document.querySelector('.el-main');
      const mainOverflowY = main ? getComputedStyle(main).overflowY : '';
      const isMainScrollable = main && (main.scrollHeight > main.clientHeight) && (mainOverflowY !== 'visible');
      const el = isMainScrollable ? main : rootEl;

      const easeInOutCubic = (t) => (t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2);

      // 起始位置与时长
      const start = isMainScrollable
        ? el.scrollTop
        : (window.pageYOffset || rootEl.scrollTop || document.body.scrollTop || 0);
      const duration = 500; // ms
      const startTime = performance.now();

      const step = (now) => {
        const elapsed = Math.min((now - startTime) / duration, 1);
        const progress = easeInOutCubic(elapsed);
        const value = Math.round(start * (1 - progress));

        if (isMainScrollable) {
          el.scrollTop = value;
        } else {
          // 根容器兼容性写入
          rootEl.scrollTop = value;
          document.documentElement.scrollTop = value;
          document.body.scrollTop = value;
          if (typeof window.scrollTo === 'function') {
            window.scrollTo(0, value);
          }
        }
        if (elapsed < 1) requestAnimationFrame(step);
      };

      requestAnimationFrame(step);
    },
    handleSelect() {
      this.isShow = true;
    },
    mouseleave(type) {
      this[type] = false;
    },
    MouseFun(type) {
      // 停止定时器            // 重新执行定时器
      this[type] = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.sideList {
  position: fixed;
  width: 48px;
  z-index: 50;
  top: 80vh;
  margin: -100px 0 0 0;
  right: 10px;
  background-color: #111111;
  border-radius: 20px;
}

.sideList__item {
  height: 48px;
  background-position: center;
  display: block;
  cursor: pointer;
}

.sideList__tel {
  background-image: url(../assets/icon/tel-side.png);
}

.sideList__top {
  background-image: url(../assets/icon/top-side.png);
}

.sideList__qq {
  background-image: url(../assets/icon/qq-side.png);
}

.sideList__topOutside {
  margin-right: 50px;
  height: 48px;
  float: right;
  background-color: transparent;
}

.sideList__topShow {
  color: white;
  float: right;
  width: 120px;
  height: 48px;
  margin-right: 4px;
  border-radius: 8px;
  text-align: center;
  line-height: 48px;
  font-size: 15px;
  background-color: #111111;
}

.sideList__tel .sideList__topShow {
  font-size: 13px;
}

.sideList__triangle {
  width: 0;
  height: 0;
  border-width: 10px 10px 10px 0px;
  border-style: solid;
  border-color: transparent #d7d7d7;
  float: right;
  margin-top: 14px;
}
</style>
